import {gql} from "@apollo/client";

export const UPDATE_INTERCOM_NETWORK_CONFIG = gql`
    mutation Mutation($input: UpdateIntercomNetworkConfigInput!) {
  updateIntercomNetworkConfig(input: $input) {
    success
    notice
  }
}`
